/**
 * Created by denis.gusarov on 3/7/2017.
 */
namespace Factive.Core {

    export interface IIOCFactory {
        DependenciesContainer: DependenciesContainer;
        get: Function;
        dependency: Array<string>;
    }

    export class DependenciesContainer {

        private ioc: CompactIOC;

        constructor() {
            this.ioc = new CompactIOC();
            this.singleton("DependenciesContainer", this);
        }

        public register (name, dep) {
            return this.ioc.pub(name, dep.factory);
        };

        public singleton (name, dep) {
            return this.ioc.pub(name, function() {
                return dep;
            });
        };

        public get (name, options = null) {
            var o = this.ioc.get(name, {}, options);
            return o;
        };

        public bootstrap(deps) {
            deps.jquery = {
                $: deps.$
            };

            var ref = Object.keys(deps);
            for (var i = 0, len = ref.length; i < len; i++) {
                let name = ref[i];
                this.singleton(name, deps[name]);
            }
        };

        public registerScripts(RequireScripts) {
            var ref1 = RequireScripts.keys();
            for (var j = 0, len1 = ref1.length; j < len1; j++) {
                let path = ref1[j];
                let name = path.replace(/^\.\/[A-z]+\//, '');
                var dep = RequireScripts(path);
                this.register(name, dep);
            }
        }

        public registerTemplates(RequireTemplates) {
            var ref2 = RequireTemplates.keys();
            for (var k = 0, len2 = ref2.length; k < len2; k++) {
                let view = ref2[k];
                this.singleton(view.substring(2), RequireTemplates(view));
            }
        }
    }
}




// WEBPACK FOOTER //
// src/typescript/Core/DependenciesContainer.ts